import React, { useMemo } from 'react';
import Box from '@rsos/components/capstone/base/Box';
import { ItemIconWrapper, ItemTitle } from '../common/SideBarItem.styles';
import SmartLink from '../common/SmartLink';
import type { SideBarMenuItem } from '../common/types';

interface SideBarItemProps {
  activeItem: string;
  menuItem: SideBarMenuItem;
  sideBarOpen: boolean;
}

const SideBarItem = ({
  activeItem,
  menuItem,
  sideBarOpen,
}: SideBarItemProps) => {
  const isActive = useMemo(
    () => menuItem.name === activeItem,
    [menuItem, activeItem],
  );
  return (
    <SmartLink
      to={menuItem.link}
      toolTip={menuItem.hoverText}
      className={isActive ? ' active' : ''}
    >
      <Box horizontal flow={10}>
        <ItemIconWrapper isActive={isActive}>
          {menuItem.menuIcon}
        </ItemIconWrapper>
        <ItemTitle isActive={isActive}>
          {sideBarOpen ? menuItem.menuTitle : ''}
        </ItemTitle>
      </Box>
    </SmartLink>
  );
};

export default SideBarItem;
